import { useEffect, useRef, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useDispatch } from "react-redux";
import FormBuilder from "../../formBuilder/formBuilder";
import { createForm, updateForm } from "../../../../store/slices/formBuilder";
import PreviewForm from "../../formBuilder/previewForm";

const CreateFormModal = ({
  isOpen,
  toggle,
  editForm,
  formData,
  selectedSubService,
}) => {
  const formBuilderRef = useRef();
  const dispatch = useDispatch();
  const [form, setForm] = useState([]);
  const [json, setJson] = useState([]);
  const [type, setType] = useState("form");
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    console.log(selectedSubService, "selectedSubService");
    if (formData) {
      setForm(editForm);
    }
  }, [editForm]);

  const createFormData = () => {
    const cleanGrid = (formDataArr) =>
      (formDataArr || []).map((r) => ({
        columns: r.columns.map((c) => {
          if (!c?.input) return { input: null };
          const inp = { ...c.input };
          const isApiSource = inp.isAPI || inp.sourceType === "api";
          const isSchemaSource = inp.sourceType === "schema" || inp.API?.useSchema;
          if (isApiSource || isSchemaSource) {
            delete inp.options;
            delete inp.tempOptions;
            delete inp._apiFetched;
            delete inp._schemaFetched;
            delete inp._schemaPreviewFetched;
          }
          return { input: inp };
        }),
      }));

    if (formData) {
      let payload = {
        formID: formData.ID,
        grid: JSON.stringify(cleanGrid(form)),
      };
      dispatch(updateForm(payload));
    } else {
      console.log(selectedSubService, "selectedSubService");
      let payload = {
        formName: selectedSubService.name,
        sub_service_id: selectedSubService.ID,
        grid: JSON.stringify(cleanGrid(form)),
      };
      dispatch(createForm(payload));
    }
  };

  const handleNext = () => {
    formBuilderRef.current.set();
    if (activeTab === 1) setActiveTab(2);
  };

  const handleBack = () => {
    if (activeTab === 2) setActiveTab(1);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader className="w-full">
        {formData ? "Edit Form" : "Create Form"}
      </ModalHeader>
      <ModalBody>
        <>
          {activeTab === 1 ? (
            <FormBuilder
              ref={formBuilderRef}
              setForm={setForm}
              setJson={setJson}
              formData={form || []}
              jsonData={json || []}
            />
          ) : null}

          {activeTab === 2 ? (
            <PreviewForm grid={form} type={type} json={json} />
          ) : null}
        </>
      </ModalBody>
      <ModalFooter className="d-flex customModalFooter">
        {activeTab === 1 ? (
          <button className="btn bg-primary" onClick={() => handleNext()}>
            Preview Form
          </button>
        ) : (
          <>
            <button className="btn bg-white" onClick={() => handleBack()}>
              back
            </button>
            <button className="btn bg-primary" onClick={() => createFormData()}>
              {formData ? "Edit" : "Create"}
            </button>
          </>
        )}
        <button className="btn bg-danger" onClick={toggle}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateFormModal;
